import GiftPointRedemptionPanel from "./giftPointRedemptionPanel.container"

export default GiftPointRedemptionPanel
